import { useState } from "react";
import axios from "axios";
import { useNavigate } from "react-router-dom";

export default function CreateJob() {
  const navigate = useNavigate();

  const [title, setTitle] = useState("");
  const [paragraph, setParagraph] = useState("");
  const [location, setLocation] = useState("");
  const [salary, setSalary] = useState("");
  const [timing, setTiming] = useState("");
  const [isActive, setIsActive] = useState(true);
  const [image, setImage] = useState(null);
  const [loading, setLoading] = useState(false);
  const [message, setMessage] = useState("");

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setMessage("");

    try {
      const formData = new FormData();
      formData.append("title", title);
      formData.append("paragraph", paragraph);
      formData.append("location", location);
      formData.append("salary", salary);
      formData.append("timing", timing);
      formData.append("isActive", isActive);
      if (image) formData.append("image", image);

      const res = await axios.post(
        "http://localhost:5000/api/job/",
        formData,
        {
          headers: { "Content-Type": "multipart/form-data" },
        }
      );

      setMessage("Job created successfully");
      setLoading(false);

      setTimeout(() => navigate("/admin/dashboard"), 1000);
    } catch (error) {
      setMessage("Failed to create job");
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen bg-gray-100 p-6 flex justify-center">
      <div className="bg-white shadow-lg rounded-xl p-6 w-full max-w-2xl">
        <h2 className="text-2xl font-bold text-gray-800 mb-4">Create New Job</h2>

        {message && (
          <div className="mb-4 text-center text-sm text-blue-600 font-medium">
            {message}
          </div>
        )}

        <form onSubmit={handleSubmit} className="space-y-4">
          <div>
            <label className="block mb-1 font-medium text-gray-700">Job Title</label>
            <input
              type="text"
              value={title}
              onChange={(e) => setTitle(e.target.value)}
              required
              className="w-full border p-2 rounded-md"
            />
          </div>

          <div>
            <label className="block mb-1 font-medium text-gray-700">Description</label>
            <textarea
              value={paragraph}
              onChange={(e) => setParagraph(e.target.value)}
              required
              className="w-full border p-2 rounded-md h-24"
            ></textarea>
          </div>

          <div>
            <label className="block mb-1 font-medium text-gray-700">Location</label>
            <input
              type="text"
              value={location}
              onChange={(e) => setLocation(e.target.value)}
              className="w-full border p-2 rounded-md"
            />
          </div>

          <div>
            <label className="block mb-1 font-medium text-gray-700">Salary</label>
            <input
              type="number"
              value={salary}
              onChange={(e) => setSalary(e.target.value)}
              className="w-full border p-2 rounded-md"
            />
          </div>

          <div>
            <label className="block mb-1 font-medium text-gray-700">Timing</label>
            <input
              type="text"
              value={timing}
              onChange={(e) => setTiming(e.target.value)}
              placeholder="e.g., 10 AM - 6 PM"
              className="w-full border p-2 rounded-md"
            />
          </div>

          <div>
            <label className="block mb-1 font-medium text-gray-700">Status</label>
            <select
              value={isActive}
              onChange={(e) => setIsActive(e.target.value === "true")}
              className="w-full border p-2 rounded-md"
            >
              <option value="true">Active</option>
              <option value="false">Inactive</option>
            </select>
          </div>

          <div>
            <label className="block mb-1 font-medium text-gray-700">Job Image</label>
            <input
              type="file"
              accept="image/*"
              onChange={(e) => setImage(e.target.files[0])}
              className="w-full"
            />
          </div>

          <button
            type="submit"
            disabled={loading}
            className="w-full bg-indigo-600 text-white py-2 rounded-md hover:bg-indigo-700 transition"
          >
            {loading ? "Creating..." : "Create Job"}
          </button>
        </form>
      </div>
    </div>
  );
}